import axiosIns from '@/libs/axios'

const ROOT_URL = '/edges'

export default {
  namespaced: true,
  state: {
    dataList: [],
    metaData: {
      total: 0, page: 1, limit: 50, totalPages: 0,
    },
    activeList: [],
    scanResult: null,
    scanLoading: false,
    dataSave: { message: null, status: null, id: null },
  },
  getters: {
    dataList: s => s.dataList,
    metaData: s => s.metaData,
    activeList: s => s.activeList,
    scanResult: s => s.scanResult,
    scanLoading: s => s.scanLoading,
    dataSaveStatus: s => s.dataSave,
  },
  mutations: {
    SET_DATA_LIST(state, data) { state.dataList = data },
    SET_META_DATA(state, data) { state.metaData = data },
    SET_ACTIVE_LIST(state, data) { state.activeList = data },
    SET_SCAN_RESULT(state, data) { state.scanResult = data },
    SET_SCAN_LOADING(state, val) { state.scanLoading = val },
    SET_DATA_SAVE(state, data) { state.dataSave = data },
  },
  actions: {
    getDataList({ commit }, params) {
      return axiosIns.post(ROOT_URL, params || {})
        .then(response => {
          commit('SET_DATA_LIST', response.data.data)
          commit('SET_META_DATA', response.data.meta || {
            total: 0, page: 1, limit: 50, totalPages: 0,
          })
        })
        .catch(error => {
          console.error(error)
          commit('SET_DATA_SAVE', { status: false, message: 'Edge listesi alınamadı.' })
        })
    },
    getActive({ commit }) {
      return axiosIns.get(`${ROOT_URL}/active`)
        .then(response => {
          commit('SET_ACTIVE_LIST', response.data.data)
        })
        .catch(error => {
          console.error(error)
        })
    },
    runScan({ commit }, body) {
      commit('SET_SCAN_LOADING', true)
      commit('SET_SCAN_RESULT', null)
      return axiosIns.post(`${ROOT_URL}/scan`, body)
        .then(response => {
          commit('SET_SCAN_RESULT', response.data.data)
          commit('SET_SCAN_LOADING', false)
          commit('SET_DATA_SAVE', {
            status: true,
            message: `Scan: ${response.data.data.passed}/${response.data.data.total} geçti, ${response.data.data.savedEdges} kayıt edildi`,
          })
        })
        .catch(error => {
          console.error(error)
          commit('SET_SCAN_LOADING', false)
          const msg = error?.response?.data?.message || 'Scan başarısız.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
        })
    },
    toggleActive({ commit, dispatch }, { id, isActive }) {
      return axiosIns.patch(`${ROOT_URL}/${id}/active`, { isActive })
        .then(response => {
          commit('SET_DATA_SAVE', { status: true, message: response.data.message })
          dispatch('getActive')
        })
        .catch(error => {
          console.error(error)
          commit('SET_DATA_SAVE', { status: false, message: 'Durum değiştirilemedi.' })
        })
    },
    rescanNow({ commit, dispatch }, { kind = 'BOTH' } = {}) {
      return axiosIns.post(`${ROOT_URL}/rescan-now`, { kind })
        .then(response => {
          const data = response.data.data || {}
          let act = 0; let deact = 0
          if (data.activated) { act = data.activated.length; deact = (data.deactivated || []).length } else if (data.normal || data.quickGain) {
            act = (data.normal?.activated?.length || 0) + (data.quickGain?.activated?.length || 0)
            deact = (data.normal?.deactivated?.length || 0) + (data.quickGain?.deactivated?.length || 0)
          }
          commit('SET_DATA_SAVE', { status: true, message: `Rescan: +${act} aktive, -${deact} pasifleştirildi.` })
          dispatch('getDataList', {})
          dispatch('getActive')
        })
        .catch(error => {
          console.error(error)
          const msg = error?.response?.data?.message || 'Rescan başarısız.'
          commit('SET_DATA_SAVE', { status: false, message: msg })
        })
    },
    bulkToggle({ commit, dispatch }, { ids, isActive }) {
      return axiosIns.patch(`${ROOT_URL}/bulk/active`, { ids, isActive })
        .then(response => {
          commit('SET_DATA_SAVE', { status: true, message: response.data.message })
          dispatch('getActive')
        })
        .catch(error => {
          console.error(error)
          commit('SET_DATA_SAVE', { status: false, message: 'Toplu işlem başarısız.' })
        })
    },
    removeEdge({ commit }, id) {
      return axiosIns.delete(`${ROOT_URL}/${id}`)
        .then(response => {
          commit('SET_DATA_SAVE', { status: true, message: response.data.message })
        })
        .catch(error => {
          console.error(error)
          commit('SET_DATA_SAVE', { status: false, message: 'Silme başarısız.' })
        })
    },
    bulkRemove({ commit }, ids) {
      return axiosIns.post(`${ROOT_URL}/bulk/remove`, { ids })
        .then(response => {
          commit('SET_DATA_SAVE', { status: true, message: response.data.message })
        })
        .catch(error => {
          console.error(error)
          commit('SET_DATA_SAVE', { status: false, message: 'Toplu silme başarısız.' })
        })
    },
  },
}
